import { useState } from 'react'
import Reveal from '../Reveal/Reveal'
import SectionTitle from '../SectionTitle/SectionTitle'
import ExperienceSlider from './ExperienceSlider/ExperienceSlider'
import ExperienceData from '../../data/ExperienceData'
import styles from "./Experience.module.css"
import { AppConstants } from '../../AppConstants'

const Experience = () => {

    const [currentIndex, setCurrentIndex] = useState(0);

    const nextExperience = () => {
        setCurrentIndex(prevIndex =>
            prevIndex === (ExperienceData.length - 1) ? 0 : (prevIndex + 1)
        )
    }

    const preExperience = () => {
        setCurrentIndex(prevIndex =>
            prevIndex === 0 ? (ExperienceData.length - 1) : (prevIndex - 1)
        )
    }
    return (
        <section id='experience' className={styles['experience-slider']}>
            <Reveal>
                <div className="container">
                    <SectionTitle>
                        <span>{AppConstants.CommonWords.My}</span> {AppConstants.NavigationMenus.Experience}
                    </SectionTitle>
                    <ExperienceSlider ExperienceDataItem={ExperienceData[currentIndex]} nextExperienceItem={nextExperience} preExperienceItem={preExperience} />
                </div>
            </Reveal>
        </section>
    )
}

export default Experience
